import React from 'react'
import { LYSAlert, LYSButton, LYSTypography } from '@core/components/Primitives'
import { ALTERNATIVE_CONTAINER_ID } from '@core/components/ProductDetail/ProductRelations/FollowUpProductRelations'
import { useTranslation } from '@core/i18n/i18n'
import { useProductDetailContext } from '@core/utils/models/product/ProductContext'
import { scrollVerticalToElement } from '@core/utils/scrolling'
import styles from './index.module.less'

const DiscontinuedHint: React.FC = () => {
  const { t } = useTranslation()
  const { product } = useProductDetailContext() || {}

  if (!product || !product.isDiscontinued) {
    return null
  }

  const handleCtaPress = () => {
    scrollVerticalToElement({ elementId: ALTERNATIVE_CONTAINER_ID })
  }

  return (
    <LYSAlert
      className={styles.discontinued_hint}
      message={''}
      type={'warning'}
      description={
        <>
          <LYSTypography.Text>{t`product.discontinued.hint`}</LYSTypography.Text>
          <LYSButton
            onClick={handleCtaPress}
            actionButtonStyle
            type="primary"
            className={styles.discontinued_cta}
          >
            {t`product.discontinued.cta`}
          </LYSButton>
        </>
      }
    />
  )
}

export default DiscontinuedHint
